import { useContext, useEffect } from 'react';

import { useDatadogContext } from '@/context/hooks/useDatadogContext';

import { LogPageContext, LogPageContextType } from './LogPageContext';

// note: memoize the context to avoid logging on every render
export const useInfoLogger = (manualContext?: LogPageContextType) => {
  const { datadogLogs } = useDatadogContext();
  const pageContext = useContext(LogPageContext);
  const [page, metadata] = pageContext ?? manualContext ?? [];

  useEffect(() => {
    if (!metadata || !page) {
      return;
    }
    datadogLogs?.logger?.info(`${page}__info`, {
      page,
      ...metadata,
    });
  }, [page, metadata, datadogLogs]);
};
